import React from "react";


const Footer = () => {
  return (
    <footer>
      &copy;&nbsp;2022 - {new Date().getFullYear()}&nbsp;
      <a href="https://buildyourai.consulting/aibidassist" target="_blank">Build your AI here</a>
    </footer>
  );
};

export default Footer;
